export default function audioController() {
    return {
				backgroundTrack: null,

        init() {
					const self = this

					const backgroundTrack = document.querySelector('#backgroundTrack')

					if (backgroundTrack !== null) {
						this.$store.audio.backgroundTrack = new Audio(backgroundTrack.getAttribute('data-src'));

						this.$store.audio.backgroundTrack.loop = true;
						this.$store.audio.backgroundTrack.muted = this.$store.audio.isMuted;
						this.$store.audio.backgroundTrack.volume = 0.5;
						this.$store.audio.backgroundTrack.load();
						this.$store.audio.backgroundTrack.pause();
					}

					// Detect visibility change (browser minimised/locked)
					document.addEventListener('visibilitychange', function() {
						self.handleVisibilityChange(self)
					});

					// Detect focus change (app minimised or phone locked)
					window.addEventListener('focus', function() {
						self.handleFocusChange(self)
					});

					window.addEventListener('blur', function() {
						self.handleFocusChange(self)
					});
        },

				handleVisibilityChange(self) {
					if (document.hidden) {
						this.$store.audio.backgroundTrack.pause();
					} else {
						this.$store.audio.backgroundTrack.play();
					}
				},

				handleFocusChange(self) {
					if (!document.hasFocus()) {
						this.$store.audio.backgroundTrack.pause();
					} else {
						this.$store.audio.backgroundTrack.play();
					}
				},

        toggleAudio() {
						this.$store.audio.isMuted = !this.$store.audio.isMuted;

            // Mute/unmute all audio elements
            if (this.$store.audio.isMuted) {
                this.muteAllAudio();
            } else {
                this.unmuteAllAudio();
            }
        },

        muteAllAudio() {
            console.log('Muting all audio');

						this.$store.audio.backgroundTrack.muted = true;
						this.$store.audio.backgroundTrack.pause();

            // Target actual audio elements instead of canvas
            document.querySelectorAll('audio, video').forEach(element => {
                element.muted = true;
            });
        },

        unmuteAllAudio() {
						console.log('Unmuting all audio');

						this.$store.audio.backgroundTrack.muted = false;
						this.$store.audio.backgroundTrack.play();

            // Target actual audio elements instead of canvas
            document.querySelectorAll('audio, video').forEach(element => {
                element.muted = false;
            });
        }
    };
}
